<script lang="ts">
  import { AlertTriangle } from 'lucide-svelte';
  import DialogWrapper from '../ui/dialog-wrapper.svelte';
  import Button from '../ui/button.svelte';

  let {
    open = false,
    onClose,
    onConfirm,
    isDeleting = false,
    error = null,
  }: {
    open: boolean;
    onClose: () => void;
    onConfirm: (reason: string, backup: boolean) => void;
    isDeleting?: boolean;
    error?: string | null;
  } = $props();

  let deletionReason = $state('');
  let backupRequested = $state(true);

  $effect(() => {
    if (!open) {
      deletionReason = '';
      backupRequested = true;
    }
  });

  function handleConfirm() {
    onConfirm(deletionReason, backupRequested);
  }
</script>

<DialogWrapper {open} onClose={onClose} title="Smazat účet">
  {#snippet headerIcon()}
    <div class="p-2 bg-destructive/10 rounded-full">
      <AlertTriangle class="w-6 h-6 text-destructive" />
    </div>
  {/snippet}

  <div class="space-y-4">
        <p class="text-muted-foreground">
          Skutečně chcete smazat svůj účet?
        </p>
        {#if error}
          <div class="p-3 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive text-sm">
            {error}
          </div>
        {/if}

        <!-- Deletion Reason -->
        <div class="space-y-2">
          <label for="deletion-reason" class="form-label">
            Důvody zrušení (nepovinné)
          </label>
          <textarea
            id="deletion-reason"
            bind:value={deletionReason}
            placeholder="Řekněte nám prosím proď odcázíte..."
            rows="3"
            class="form-textarea"
            disabled={isDeleting}
          ></textarea>
        </div>

        <!-- Backup Checkbox -->
        <div class="flex items-center gap-2">
          <input
            id="backup-data"
            type="checkbox"
            bind:checked={backupRequested}
            class="w-4 h-4 rounded border-border"
            disabled={isDeleting}
          />
          <label for="backup-data" class="text-sm text-foreground cursor-pointer">
            Zálohovat data
          </label>
        </div>

    <div class="p-3 bg-warning/10 border border-warning/20 rounded-lg">
      <p class="text-sm text-warning">
        <strong>Varu:</strong> Tato akce je nevratná. Všechna vaše data budou trvalě smázána.
      </p>
    </div>

    <!-- Footer -->
    <div class="mt-6 flex gap-3">
      <Button
        variant="outline"
        onclick={onClose}
        class="btn btn-secondary flex-1"
        disabled={isDeleting}
      >
        Zrušit
      </Button>
      <Button
        onclick={handleConfirm}
        class="btn btn-destructive flex-1"
        disabled={isDeleting}
      >
        {isDeleting ? 'Mažu...' : 'ANO'}
      </Button>
    </div>
  </div>
</DialogWrapper>
